// extracted by mini-css-extract-plugin
module.exports = {"backdrop":"Modal_backdrop__CkVGk","contentBox":"Modal_contentBox__LyUK0","innerBoxWithBorder":"Modal_innerBoxWithBorder__MHEbY"};